import {
    Container,
    MaterialContext,
    Text,
    ThemeContext,
} from '@wonderlandengine/react-ui/components';
import { Align, Justify, ReactUiBase } from '@wonderlandengine/react-ui';
import React, { useState, useEffect } from 'react';

const CaptionsComponent = (props: { comp: Captions }) => {
    const [text, setText] = useState(props.comp?.description);

    useEffect(() => {
        const updateText = () => setText(props.comp.description);
        props.comp.setUpdateCallback(updateText);

        return () => {
            props.comp.removeUpdateCallback();
        };
    }, [props.comp]);
    useEffect(() => {
        setText(props.comp.description);
    }, [props.comp.description]);

    const theme = {
        colors: {
            background: '#00000000',
            text: '#ffffff',
            primary: '#ffffff',
            secondary: '#ffffff',
            accent: '#ffffff',
        },
    };
    return (
        <MaterialContext.Provider value={props.comp}>
            <ThemeContext.Provider value={theme}>
                <Container left={-25} top={-15}>
                    <Container
                        width={50}
                        padding={5}
                        alignItems={Align.Center}
                        justifyContent={Justify.Center}
                    >
                        <Text
                            fontSize={2}
                            textAlign="center"
                            text={text}
                            textWrap="soft"
                        ></Text>
                    </Container>
                </Container>
            </ThemeContext.Provider>
        </MaterialContext.Provider>
    );
};

export class Captions extends ReactUiBase {
    static TypeName = 'ui:captions';
    static InheritProperties = true;

    private _description = '';
    get description(): string {
        return this._description;
    }

    set description(value: string) {
        if (this._description !== value) {
            this._description = value;
            if (this._updateCallback) {
                this._updateCallback();
            }
        }
    }

    override async start(): Promise<void> {
        super.start();
    }

    override update(dt: number) {
        super.update(dt);
    }

    private _updateCallback?: () => void;
    public setUpdateCallback(callback: () => void | undefined): void {
        this._updateCallback = callback;
    }
    public removeUpdateCallback(): void {
        this._updateCallback = undefined;
    }

    render() {
        return <CaptionsComponent comp={this} />;
    }
}
